// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dob-select{width:100px}.dob-select .vs__dropdown-toggle{border-top:none;border-right:none;border-left:none}.badge .bg-danger{background-color:var(--primary)!important}body{font-family:Poppins,sans-serif;font-size:14px}.vs__selected-options{height:32px}", ""]);
// Exports
module.exports = exports;
